module.exports = __webpack_public_path__ + "static/img/20f.18add70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20f.jpg
// module id = N04e
// module chunks = 0